import { lazy, Suspense, useState } from "react";
import { LayoutUserCafe } from "../../layout/layout_cafe";

const PancakeArena = lazy(() => import("../../components/PancakeArena"));
const WitchArena = lazy(() => import("../../components/WitchArena"));
const options = ['Pancake Tower', "Witch's Coffee Run"] as const;

const GamePage: React.FC = () => {
  const [selected, setSelected] = useState(0);
  return <LayoutUserCafe>
    <div className="min-h-screen bg-white font-sans pb-[40px]">
      <div className="max-w-[760px] mx-auto px-4 sm:px-5 pt-[24px]">
        <p className="eyebrow-v2 mb-2">Mini game</p>
        <h1 className="font-display font-black text-[28px] leading-[1.15] tracking-tightest text-ink-1000">พักเบรก เล่นสักตา</h1>
        <div role="tablist" aria-label="เลือกเกม" className="flex flex-wrap gap-2 my-4">
          {options.map((name, index) => <button key={name} id={`game-tab-${index}`} role="tab" type="button"
            aria-selected={selected === index} aria-controls={`game-panel-${index}`} tabIndex={selected === index ? 0 : -1}
            className={`min-h-[48px] px-4 py-2 rounded-full text-sm font-bold border ${selected === index ? 'bg-ink-1000 text-white border-ink-1000' : 'bg-white text-ink-700 border-ink-200'}`}
            onClick={() => setSelected(index)} onKeyDown={event => {
              if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
              event.preventDefault();
              const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - selected;
              setSelected(next);
              document.getElementById(`game-tab-${next}`)?.focus();
            }}>{name}</button>)}
        </div>
        <section id={`game-panel-${selected}`} role="tabpanel" aria-labelledby={`game-tab-${selected}`}>
          {selected === 0
            ? <p className="text-sm text-ink-500 mt-2 mb-4">แตะวางแพนเค้กซ้อนให้ตรง วางเป๊ะได้โบนัส แข่งอันดับกับเพื่อนในออฟฟิศ</p>
            : <h2 className="text-sm font-bold text-ink-700 mt-2 mb-4">Hardcore</h2>}
          <Suspense fallback={<p className="text-sm text-ink-500 py-10 text-center">กำลังโหลดเกม…</p>}>
            {selected === 0 ? <PancakeArena /> : <WitchArena />}
          </Suspense>
        </section>
      </div>
    </div>
  </LayoutUserCafe>;
};
export default GamePage;
